import { getRuntimeValue } from './config/runtime';
// 
// const VUE_APP_WS_URL = getRuntimeValue('VUE_APP_WS_URL') || process.env.VUE_APP_WS_URL || 'ws://api.rblnhoopdhot.com/websocket';
// const VUE_APP_BASEURL = getRuntimeValue('VUE_APP_BASEURL') || process.env.VUE_APP_BASEURL || 'https://api.rblnhoopdhot.com';
// const SERVICE_URL = getRuntimeValue('VUE_APP_SERVICE_URL') || process.env.VUE_APP_SERVICE_URL || 'https://google.com';
const VUE_APP_WS_URL = 'ws://api.jiekouduogongnengpan.com/websocket';
const VUE_APP_BASEURL = 'https://api.jiekouduogongnengpan.com';
// const VUE_APP_BASEURL = 'http://localhost:8080';
const SERVICE_URL = 'https://zliko.coqbjjguytdys.in//index?key=e16183c21228ab28bb913d297c4e734d&lang=en';

export { VUE_APP_WS_URL, VUE_APP_BASEURL, SERVICE_URL };
